export const AuthAppUserKey = 'auth-app-users';
export const AppUsersKey = 'app-users';
export const AppUsersGetOneKey = 'app-users-get-one';
export const CSVImport = 'csv-import';
export const AppUserPermissionKey = 'app-user-permissions';
export const AppUserSystemPermissionKey = 'app-user-system-permissions';